import styles from "./styles.module.css";

interface QuizProgressBarProps {
  answeredQuestions: number;
  totalQuestions: number;
}

export const QuizProgressBar = ({
  answeredQuestions,
  totalQuestions,
}: QuizProgressBarProps) => {
  const remaining = Math.max(0, totalQuestions - answeredQuestions);
  const percent =
    totalQuestions > 0
      ? Math.round((answeredQuestions / totalQuestions) * 100)
      : 0;

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        {/* Progresso geral */}
        <div className={styles.section}>
          <div className={styles.labelRow}>
            <span className={styles.label}>Progresso da pesquisa</span>
            <span className={styles.value}>
              {remaining === 0
                ? "Todas respondidas!"
                : `Faltam ${remaining} de ${totalQuestions} questões`}
            </span>
          </div>
          <div className={styles.track}>
            <div
              className={styles.fill}
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>

        {/* Porcentagem */}
        <div className={styles.percentBadge}>{percent}%</div>
      </div>
    </div>
  );
};
